// src/services/api.js
import axios from 'axios';

// URL de tu Cloudflare Worker
const API_BASE_URL = 'https://react.tecsolapi.workers.dev/';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// **Funciones de Autenticación**
export const loginUser = async (username, password) => {
  try {
    const response = await api.post(
      '/',
      { username, password },
      { params: { action: 'login' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Productos**
export const getProductos = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarProductos' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createProducto = async (producto) => {
  try {
    const response = await api.post(
      '/',
      {
        name: producto.name,
        productType: producto.productType,
        internalRef: producto.internalRef,
        barcode: producto.barcode,
        salesPrice: producto.salesPrice,
        cost: producto.cost,
        weight: producto.weight,
        description: producto.description,
        estado: producto.estado,
      },
      { params: { action: 'crearProducto' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateProducto = async (producto) => {
  try {
    const response = await api.post(
      '/',
      {
        id: producto.id,
        name: producto.name,
        productType: producto.productType,
        internalRef: producto.internalRef,
        barcode: producto.barcode,
        salesPrice: producto.salesPrice,
        cost: producto.cost,
        weight: producto.weight,
        description: producto.description,
        estado: producto.estado,
        usuarioModificacion: producto.usuarioModificacion,
        observacion: producto.observacion,
      },
      { params: { action: 'actualizarProducto' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const deleteProducto = async (id) => {
  try {
    const response = await api.post(
      '/',
      { id },
      { params: { action: 'eliminarProducto' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Inventario**
export const getInventario = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarInventarios' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createInventario = async (inventario) => {
  try {
    const response = await api.post(
      '/',
      {
        idProducto: inventario.idProducto,
        idBodega: inventario.idBodega,
        stock: inventario.stock,
      },
      { params: { action: 'crearInventario' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateInventario = async (inventario) => {
  try {
    const response = await api.post(
      '/',
      {
        idInventario: inventario.idInventario,
        stock: inventario.stock,
        usuarioActualizacion: inventario.usuarioActualizacion,
      },
      { params: { action: 'actualizarInventario' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Usuarios**
export const getUsuarios = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarUsuarios' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createUsuario = async (usuario) => {
  try {
    const response = await api.post(
      '/',
      {
        username: usuario.username,
        password: usuario.password,
        rol: usuario.rol,
        estado: usuario.estado,
      },
      { params: { action: 'crearUsuario' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateUsuario = async (usuario) => {
  try {
    const response = await api.post(
      '/',
      {
        id: usuario.id,
        username: usuario.username,
        password: usuario.password,
        rol: usuario.rol,
        estado: usuario.estado,
      },
      { params: { action: 'actualizarUsuario' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const deleteUsuario = async (id) => {
  try {
    const response = await api.post(
      '/',
      { id },
      { params: { action: 'eliminarUsuario' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Bodegas**
export const getBodegas = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarBodegas' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createBodega = async (bodega) => {
  try {
    const response = await api.post(
      '/',
      {
        nombre: bodega.nombre,
        direccion: bodega.direccion,
        estado: bodega.estado,
      },
      { params: { action: 'crearBodega' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateBodega = async (bodega) => {
  try {
    const response = await api.post(
      '/',
      {
        id: bodega.id,
        nombre: bodega.nombre,
        direccion: bodega.direccion,
        estado: bodega.estado,
      },
      { params: { action: 'actualizarBodega' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const deleteBodega = async (id) => {
  try {
    const response = await api.post(
      '/',
      { id },
      { params: { action: 'eliminarBodega' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Movimientos**
export const getMovimientos = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarMovimientos' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createMovimiento = async (movimiento) => {
  try {
    const response = await api.post(
      '/',
      {
        tipo: movimiento.tipo,
        fecha: movimiento.fecha,
        estado: movimiento.estado,
        idBodega: movimiento.idBodega,
        usuario: movimiento.usuario,
        observacion: movimiento.observacion,
        proveedorCliente: movimiento.proveedorCliente,
        productos: movimiento.productos,
      },
      { params: { action: 'crearMovimiento' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateMovimiento = async (movimiento) => {
  try {
    const response = await api.post(
      '/',
      {
        id: movimiento.id,
        tipo: movimiento.tipo,
        fecha: movimiento.fecha,
        estado: movimiento.estado,
        idBodega: movimiento.idBodega,
        usuario: movimiento.usuario,
        observacion: movimiento.observacion,
        proveedorCliente: movimiento.proveedorCliente,
      },
      { params: { action: 'actualizarMovimiento' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const deleteMovimiento = async (id) => {
  try {
    const response = await api.post(
      '/',
      { id },
      { params: { action: 'eliminarMovimiento' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Funciones CRUD para Roles y Permisos**
export const getRoles = async () => {
  try {
    const response = await api.post(
      '/',
      {},
      { params: { action: 'listarRolesPermisos' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const createRol = async (rol) => {
  try {
    const response = await api.post(
      '/',
      {
        nombreRol: rol.nombreRol,
        crearProductos: rol.crearProductos ? 'Si' : 'No',
        modificarPrecios: rol.modificarPrecios ? 'Si' : 'No',
        verReportes: rol.verReportes ? 'Si' : 'No',
        crearUsuarios: rol.crearUsuarios ? 'Si' : 'No',
      },
      { params: { action: 'crearRolPermiso' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const updateRol = async (rol) => {
  try {
    const response = await api.post(
      '/',
      {
        idRol: rol.idRol, // Asegúrate de que 'idRol' esté incluido en el payload
        nombreRol: rol.nombreRol,
        crearProductos: rol.crearProductos ? 'Si' : 'No',
        modificarPrecios: rol.modificarPrecios ? 'Si' : 'No',
        verReportes: rol.verReportes ? 'Si' : 'No',
        crearUsuarios: rol.crearUsuarios ? 'Si' : 'No',
      },
      { params: { action: 'actualizarRolPermiso' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

export const deleteRol = async (nombreRol) => {
  try {
    const response = await api.post(
      '/',
      { nombreRol },
      { params: { action: 'eliminarRolPermiso' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// **Nueva Función: Obtener Stock de una Bodega**
export const getStockBodega = async (idBodega) => {
  try {
    const response = await api.post(
      '/',
      { idBodega },
      { params: { action: 'verStockBodega' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, error: 'Error de red' };
  }
};

// Exportación por defecto
export default api;
